module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/936c6f5135224fb98155587e33f3159f.gif";